/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';
import { FormFieldValue, FormValidator } from 'src/core/types/form';
import * as numberValidators from 'src/core/utils/formValidators/numberValidators';

const messages = defineMessages({
    errorMessage: {
        id: 'portal.createNumberRangeValidator.errorMessage',
        defaultMessage: 'Value is out of the allowed range'
    }
});

/**
 * A factory to create a range validator for numbers. A range validator is one
 * that succeeds validation only if the value given is contained within the
 * specified range.
 */
export const createNumberRangeValidator = (params: {
    range: number[];
    maxMode?: 'include' | 'exclude';
    minMode?: 'include' | 'exclude';
    errorMessage?: ReactIntl.FormattedMessage.MessageDescriptor;
}): FormValidator => (value: FormFieldValue) => {
    let validationResult: boolean;

    if (typeof value === 'number') {
        validationResult = numberValidators.createRangeValidator(params)(value);
    }

    if (!validationResult) {
        return { messageDescriptor: params?.errorMessage || messages.errorMessage };
    }
};
